"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExpressions = getExpressions;
exports.isSqlQuery = isSqlQuery;
const types_1 = require("../types");
const { Parser } = require("node-sql-parser/build/postgresql");
function getExpressions(text) {
    return [
        ...getExpression(text, /\$\{[A-Za-z0-9_]+\/.+?\}/g, types_1.META_EXPRESSION_TARGET_TYPE.VARIABLE),
        ...getExpression(text, /\$\^([\s\S]*?)\^/g, types_1.META_EXPRESSION_TARGET_TYPE.SQL),
    ];
    function getExpression(text, re, target) {
        let expressions = [];
        let exp;
        do {
            exp = re.exec(text);
            if (exp) {
                const val = exp.map((e) => e.substr(2, e.length - 3))[0];
                expressions.push({
                    value: val,
                    target: target != types_1.META_EXPRESSION_TARGET_TYPE.VARIABLE
                        ? isSqlQuery(val)
                            ? types_1.META_EXPRESSION_TARGET_TYPE.SQL
                            : types_1.META_EXPRESSION_TARGET_TYPE.TEXT
                        : target,
                });
            }
        } while (exp);
        return expressions;
    }
}
function isSqlQuery(text) {
    const opt = {
        database: "Postgresql",
    };
    try {
        const parser = new Parser();
        const sql = cleanSqlQuery(text);
        parser.parse(sql, opt);
        return true;
    }
    catch (error) {
        return false;
    }
}
function cleanSqlQuery(query) {
    // Remove leading and trailing whitespace
    let cleanedQuery = query.trim();
    // Remove newline characters
    cleanedQuery = cleanedQuery.replace(/\n/g, " ");
    // Replace multiple consecutive whitespace characters with a single space
    cleanedQuery = cleanedQuery.replace(/\s+/g, " ");
    return cleanedQuery;
}
